import { takeLatest } from 'redux-saga/effects';

import {
  GET_ENTITY,
  GET_ENTITY_DOCUMENTS,
  GET_ENTITY_PRODUCTS,
  GET_ENTITY_INSTRUMENTS,
  GET_ENTITY_RATING_NEWS,
  GET_ENTITY_RESEARCH,
  REQUEST_ENTITY_RATING_AND_FETCH_DATA,
  REQUEST_ENTITY_RATING,
  REQUEST_SIG_ENTITY_RATING,
} from './entityActions';
import {
  fetchEntitySaga,
  fetchEntityDocumentsSaga,
  fetchEntityProductsSaga,
  fetchEntityInstrumentsSaga,
  fetchEntityRatingNewsSaga,
  fetchEntityResearchSaga,
  requestEntityRatingSaga,
  requestEntityRatingAndFetchData,
  requestSigEntityRatingSaga,
} from './entitySaga';

export function* entityWatchers() {
  yield takeLatest(GET_ENTITY, fetchEntitySaga);
  yield takeLatest(GET_ENTITY_DOCUMENTS, fetchEntityDocumentsSaga);
  yield takeLatest(GET_ENTITY_PRODUCTS, fetchEntityProductsSaga);
  yield takeLatest(GET_ENTITY_INSTRUMENTS, fetchEntityInstrumentsSaga);
  yield takeLatest(GET_ENTITY_RATING_NEWS, fetchEntityRatingNewsSaga);
  yield takeLatest(GET_ENTITY_RESEARCH, fetchEntityResearchSaga);
  yield takeLatest(REQUEST_ENTITY_RATING, requestEntityRatingSaga);
  yield takeLatest(REQUEST_ENTITY_RATING_AND_FETCH_DATA, requestEntityRatingAndFetchData);
  yield takeLatest(REQUEST_SIG_ENTITY_RATING, requestSigEntityRatingSaga);
}
